import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer, useState } from 'react';
import ModalCloseButton from '~/components/buttons/ModalCloseButton';
import PrimaryButton from '~/components/buttons/PrimaryButton';
import SecondaryButton from '~/components/buttons/SecondaryButton';
import Modal from '~/components/modals/Modal';
import DatePicker from '../../../../components/fields/DatePicker';
import InputPicker from '../../../../components/fields/InputPicker';
import FocusTrap from '../../../../components/layout/FocusTrap';
import { compareDatesGT, getToday, validateYear, } from '../../../../services/date-time.service';
import { initEditModalState } from '../services/attendance.services';
import { modalReducer } from '../services/modal.reducer';
const EditModal = ({ closeModal, updateHandler, deleteHandler, modalData }) => {
    const [editWorkshopName, setEditWorkshopName] = useState(false);
    const [workshopId, setWorkshopId] = useState('');
    const today = getToday();
    const [modalState, dispatchModalState] = useReducer(modalReducer, initEditModalState);
    useEffect(() => {
        setEditWorkshopName(modalData.editName);
        setWorkshopId(modalData.workshopId);
        dispatchModalState({
            type: 'INITIALIZE_MODAL_STATE',
            payload: modalData,
        });
        dispatchModalState({
            type: 'FOCUS_STATE',
            id: 'startDate',
        });
    }, []);
    const updateOnClick = () => {
        validateModal();
        if (validateModal())
            updateHandler({
                attendanceId: modalState.fields.id.value,
                hoursLogged: Number(modalState.fields.hoursLogged.value),
                startDate: modalState.fields.startDate.value,
                endDate: modalState.fields.endDate.value,
                comments: modalState.fields.comments.value,
                editWorkshop: editWorkshopName,
                workshopName: modalState.fields.workshopName.value,
                workshopId: workshopId,
            });
    };
    const deleteOnClick = () => {
        deleteHandler(modalState.fields.id.value);
    };
    const validateModal = () => {
        const { startDate, endDate, hoursLogged, workshopName } = modalState.fields;
        const inValidFields = [];
        if (!validateYear(startDate.value) ||
            compareDatesGT(startDate.value, today) ||
            compareDatesGT(startDate.value, endDate.value) ||
            startDate.value === '') {
            inValidFields.push('startDate');
        }
        if (!validateYear(endDate.value) ||
            compareDatesGT(endDate.value, today) ||
            compareDatesGT(startDate.value, endDate.value) ||
            endDate.value === '') {
            inValidFields.push('endDate');
        }
        if (hoursLogged.value <= 0) {
            inValidFields.push('hoursLogged');
        }
        if (editWorkshopName && workshopName.value === '') {
            inValidFields.push('workshopName');
        }
        if (inValidFields.length > 0) {
            dispatchModalState({
                type: 'FOCUS_STATE',
                id: inValidFields[0],
            });
            inValidFields.forEach((id) => {
                dispatchModalState({
                    type: 'UPDATE_IS_VALID',
                    id: id,
                    isValid: false,
                    message: '',
                });
            });
        }
        return inValidFields.length === 0;
    };
    const modalOnChange = (event) => {
        const { value, id } = event.target;
        dispatchModalState({
            type: 'UPDATE_VALUE',
            id: id,
            value: value,
        });
        if (modalState.fields[id].validate) {
            validateHandler(id, value);
        }
    };
    const validateHandler = (id, value) => {
        let valid = true;
        let message = '';
        if (value != '') {
            if (compareDatesGT(value, today)) {
                valid = false;
                message = 'Date cannot be greater than today.';
            }
            else if (id == 'startDate' &&
                compareDatesGT(value, modalState.fields.endDate.value)) {
                valid = false;
                message = 'Start date cannot be greater than end date.';
            }
            else if (id == 'endDate' &&
                compareDatesGT(modalState.fields.startDate.value, value)) {
                valid = false;
                message = 'End date cannot be greater than start date.';
            }
        }
        dispatchModalState({
            type: 'UPDATE_IS_VALID',
            id: id,
            isValid: valid,
            message: message,
        });
    };
    return (_jsx(Modal, { children: _jsx(FocusTrap, { isActive: true, children: _jsx("div", { className: "fixed inset-0 z-10 flex items-center", children: _jsxs("div", { className: "relative m-auto flex w-full max-w-2xl flex-col justify-between overflow-auto rounded-lg bg-white shadow-md", children: [_jsxs("div", { className: "p-8", id: "modal-body", children: [_jsxs("div", { className: "flex items-center", children: [_jsx("div", { className: "m-3 mb-3 justify-start text-xl font-extrabold text-black", children: "Edit Attendance" }), _jsx(ModalCloseButton, { onClick: closeModal })] }), editWorkshopName ? (_jsx("div", { className: "m-3 mb-3", children: _jsx(InputPicker, { focus: modalState.fields.workshopName.focus, inputIsValid: modalState.fields.workshopName.isValid, inputLabel: "Workshop Name", name: "workshopName", onChange: modalOnChange, required: true, titleClass: "font-medium", type: "text", value: modalState.fields.workshopName.value }) })) : (_jsxs("div", { className: "m-3 mb-3", children: [_jsx("label", { className: "font-medium", htmlFor: "workshop-name", children: "Workshop Name:" }), _jsx("span", { className: "p-2", children: modalState.fields.workshopName.value })] })), _jsx("div", { className: "m-3 mb-3", children: _jsx(DatePicker, { errorText: modalState.fields.startDate.message, focus: modalState.fields.startDate.focus, inputIsValid: modalState.fields.startDate.isValid, inputLabel: "Start Date", max: today, name: "startDate", onChange: modalOnChange, required: true, titleClass: "font-medium", value: modalState.fields.startDate.value }) }), _jsx("div", { className: "m-3 mb-3", children: _jsx(DatePicker, { errorText: modalState.fields.endDate.message, focus: modalState.fields.endDate.focus, inputIsValid: modalState.fields.endDate.isValid, inputLabel: "End Date", max: today, name: "endDate", onChange: modalOnChange, required: true, titleClass: "font-medium", value: modalState.fields.endDate.value }) }), _jsx("div", { className: "m-3 mb-3", children: _jsx(InputPicker, { focus: modalState.fields.hoursLogged.focus, inputIsValid: modalState.fields.hoursLogged.isValid, inputLabel: "Hours", min: "0", name: "hoursLogged", onChange: modalOnChange, required: true, step: ".01", titleClass: "font-medium", type: "number", value: modalState.fields.hoursLogged.value }) }), _jsxs("div", { className: "m-3 mb-3", children: [_jsx("label", { className: "font-medium", htmlFor: "training-type", children: "Type" }), _jsx("span", { className: "p-2", children: "TRAINING" })] }), _jsxs("div", { className: "m-3 mb-3", children: [_jsx("label", { className: "font-medium", htmlFor: "password", children: "Comments" }), _jsx("textarea", { className: "block h-20 w-full rounded border-2 border-solid border-gray-100 bg-gray-100 p-2 text-cssText hover:bg-gray-200 focus:border-blue-500 focus:bg-white focus:text-black focus:outline-none", id: "comments", onChange: (event) => modalOnChange(event.target.value, event.target.id), value: modalState.fields.comments.value || '' })] })] }), _jsxs("div", { className: "flex justify-end gap-6 p-4", style: { backgroundColor: '#F5F4F7' }, children: [_jsx(SecondaryButton, { onClick: deleteOnClick, text: "Delete" }), _jsx(PrimaryButton, { onClick: updateOnClick, text: "Update" })] })] }) }) }) }));
};
export default EditModal;
